import React from "react";
import { Grid } from "@mui/material";

import "../../styles.scss";

export default function ContentFooter({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <Grid className="scd-page-content-footer" size={{ xs: 12, md: 12, lg: 12 }}>
      {children}
    </Grid>
  );
}
